const closeDropdown = (
  dropdownButton: HTMLButtonElement,
  dropdownMenu: HTMLDivElement
) => {
  dropdownButton.setAttribute("aria-expanded", "false");
  dropdownMenu.classList.add("hidden");
};

export default closeDropdown;
